module.exports = __webpack_public_path__ + "static/media/verticalDotsActive.1681abe7.svg";